import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

export async function trackAnalyticsEvent(path, payload) {
  const token = localStorage.getItem("token");
  if (!token) {
    return;
  }

  try {
    await axios.post(`${API_URL}${path}`, payload, {
      headers: {
        "Content-Type": "application/json",
        token
      }
    });
  } catch (error) {
    // Analytics should never block the user flow!
  }
}
